import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useMutation from '../../modules/react/hooks/useMutation';
import FacilityRefreshModal from '../components/FacilityRefreshModal';

const REFRESH_FACILITY_DATA = gql`
  mutation RefreshFacilityUnitGroupData($id: ID!) {
    facilityUnitGroupsRefresh(id: $id) {
      facility {
        id
      }
      userErrors {
        code
        message
      }
    }
  }
`;

const propTypes = {
  facilityId: PropTypes.string.isRequired,
};

const defaultProps = {};

const FacilityDataRefresh = ({
  facilityId,
  ...rest
}) => {
  const [refreshFacility, { loading, error, data }] = useMutation(REFRESH_FACILITY_DATA);
  let submitErrors;
  let submitted;

  const onSubmit = () => {
    refreshFacility(
      { variables: { id: facilityId } },
    );
  };

  if (data) {
    const { facility: updatedFacility, userErrors } = data.facilityUnitGroupsRefresh;

    if (updatedFacility) {
      submitted = true;
    }

    if (userErrors.length > 0) {
      submitErrors = userErrors;
      submitted = false;
    }
  }

  if (error) {
    const err = { code: 0, message: 'Could not refresh facility data.' };

    submitErrors = submitErrors ? [err, ...submitErrors] : [err];
    submitted = false;
  }

  return (
    <FacilityRefreshModal
      {...rest}
      facilityId={facilityId}
      onSubmit={onSubmit}
      submitted={submitted}
      submitting={loading}
      submitErrors={submitErrors}
    />
  );
};

FacilityDataRefresh.propTypes = propTypes;
FacilityDataRefresh.defaultProps = defaultProps;

export default FacilityDataRefresh;
